<template>
    <b-input-group class="home-sport-search d-flex">
        <b-form-input v-model="search_string" class="flex-fill search-world-input home-sport-search__input"
                      :placeholder="sportPlaceholder"></b-form-input>
        <select ref="homeSelect2" class="home-sport-search--select2"></select>
        <b-input-group-append>
            <button class="btn btn-primary search-world-button home-sport-search__btn--search" @click="sendGA">
                <i class="fa fa-search"></i>
            </button>
        </b-input-group-append>
    </b-input-group>
</template>

<script>
    export default {
        name: 'HomeSportSearch',
        props: {
            url: String,
            sportPlaceholder: String,
            cityPlaceholder: String
        },
        data() {
            return {
                municipality: null,
                search_string: null,
                municipalities: [],
                coords: []
            }
        },
        mounted() {
            this.getLocation();
            $(".search-world-input").keyup(function (event) {
                event.preventDefault();
                if (event.keyCode == 13) {
                    $(".search-world-button").click();
                }
            });

            $(this.$refs.homeSelect2).select2({
                placeholder: 'Dove?',
                "language": {
                    "noResults": function () {
                        return "Inizia a digitare";
                    }
                },
                ajax: {
                    url: `${axios.defaults.baseURL}paginate/municipalities`,
                    data: (params) => {
                        let query = {
                            term: params.term,
                            page: params.page || 1
                        }
                        return query
                    },
                    processResults: (response, params) => {
                        let results = []
                        if (response.municipalities.hasOwnProperty('data')) {
                            response.municipalities.data.forEach(m => {
                                results.push({
                                    id: m.name,
                                    text: m.name
                                })
                            })
                            params.page = response.municipalities.current_page

                            return {
                                results: results,
                                pagination: {
                                    more: (params.page * 10) < response.municipalities.total
                                }
                            }
                        }

                        return {
                            results: results,
                            pagination: {
                                more: false
                            }
                        }
                    }
                }
            });
            $(this.$refs.homeSelect2).on('select2:select', (e) => {
                this.municipality = {
                    name: e.params.data.id
                }
            });
            $(this.$refs.homeSelect2).on('select2:unselect', (e) => {
                this.municipality = {name: ''}
            });
        },
        methods: {
            getSearchUrl() {
                if (this.coords.length != 0) {
                    return this.url +
                        '?search_string=' +
                        (this.search_string != null ? this.search_string : '') +
                        '&municipality=' +
                        (this.municipality != null ? this.municipality.name : "") +
                        '&latitude=' +
                        this.coords[0] +
                        '&longitude=' +
                        this.coords[1]
                } else {
                    return this.url +
                        '?search_string=' +
                        (this.search_string != null ? this.search_string : '') +
                        '&municipality=' +
                        (this.municipality != null ? this.municipality.name : "") +
                        '&latitude=' +
                        null +
                        '&longitude=' +
                        null
                }
            },
            getLocation() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(this.returnPosition);
                }
            },
            returnPosition(position) {
                this.coords.push(position.coords.latitude);
                this.coords.push(position.coords.longitude);
                this.$bus.$emit('geolocalizated', {
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                });
            },
            sendGA() {
                ga('send', 'event', 'Ricerca', 'RicercaCorso', 'HomePage');
                window.location = this.getSearchUrl();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/home/HomeSportSearch.vue